import React from "react";
import styled from "styled-components";
import { Radius, Spacing, content, dominant } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { tr } from "@radarly/i18n";
import { PastedFilter } from "@radarly/models/insight-pages/editor";
import FilterChip from "./chips";

interface IProps {
  filters: PastedFilter[];
  onSelect: (index: number) => void;
  locale: Locale;
  selectedIndex: number;
}

const Text = styled.p`
  color: ${(props) => content(props, "secondary")};
`;

const Label = styled.p`
  color: ${(props) => content(props, "primary")};
`;

const Filter = styled.button<{ isActive: boolean }>`
  width: 100%;
  text-align: left;
  margin: ${Spacing.Medium} 0;
  border-radius: ${Radius.MediumLarge};
  border: 2px solid;
  background: transparent;
  cursor: pointer;
  border-color: ${(props) =>
    props.isActive ? dominant(props) : content(props, "tertiary")};
  padding: ${Spacing.Medium};
`;

const List = styled.div`
  margin-top: ${Spacing.Medium};
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacing.Medium};
  pointer-events: none;
`;

export default function PastedFilters({
  filters,
  onSelect,
  locale,
  selectedIndex,
}: IProps) {
  return filters.length > 0 ? (
    <div>
      <Text>{tr(locale, "INSIGHT_PAGE_COPIED_FILTERS_TEXT")}</Text>
      <div style={{ marginTop: Spacing.Medium }}>
        {filters.map((filter, i) => (
          <Filter
            key={i}
            isActive={i === selectedIndex}
            onClick={() => onSelect(i)}
          >
            <Label>
              {tr(locale, "INSIGHT_PAGE_PASTED_FILTER_LABEL", {
                title: filter.cardTitle,
              })}
            </Label>
            <List>
              {filter.clauses.map(({ clause, field }, index) => (
                <FilterChip
                  key={`${field}_${index}}`}
                  clause={clause}
                  field={field}
                  period={filter.period}
                  locale={locale}
                />
              ))}
            </List>
          </Filter>
        ))}
      </div>
    </div>
  ) : (
    <div>
      <Text style={{ marginBottom: Spacing.Medium }}>
        {tr(locale, "INSIGHT_PAGE_NO_FILTERS_COPIED")}
      </Text>
      <Text>{tr(locale, "INSIGHT_PAGE_NO_FILTER_COPIED_TEXT")}</Text>
    </div>
  );
}
